import {Helmet} from "react-helmet";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import {RouteHelper} from "../../../route/RouteHelper";
import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import ProductBasicInfo from "../productBasicInfo/ProductBasicInfo";
import ProductEnabled from "../productEnabled/ProductEnabled";
import ProductVariant from "../../productVariant/ProductVariant";
import ProductImages from "../../productImages/ProductImages";

export default function ProductDetails() {

    const {id: productId = -1} = useParams()

    const {state} = useLocation()
    const [productTitle, setProductTitle] = useState(state && state.title ? state.title : RouteHelper.ProductDetails.name);
    const [tabSelectedValue, setTabSelectedValue] = useState(tabTypes.basicInfo.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title>{productTitle}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Products.name,
                                RouteHelper.Products.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                productTitle,
                                ""
                            )
                        ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabSelectedValue}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab
                                    label={tabTypes.basicInfo.title}
                                    value={tabTypes.basicInfo.id}/>
                                <Tab
                                    label={tabTypes.productImages.title}
                                    value={tabTypes.productImages.id}/>
                                <Tab
                                    label={tabTypes.productVariant.title}
                                    value={tabTypes.productVariant.id}/>
                                <Tab
                                    label={tabTypes.enabled.title}
                                    value={tabTypes.enabled.id}/>
                            </TabList>
                        </Box>
                        <TabPanel value={tabTypes.basicInfo.id}>
                            <ProductBasicInfo productId={productId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.productImages.id}>
                            <ProductImages productId={productId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.enabled.id}>
                            <ProductEnabled productId={productId}/>
                        </TabPanel>
                        <TabPanel value={tabTypes.productVariant.id}>
                            <ProductVariant productId={productId}/>
                        </TabPanel>
                    </TabContext>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}
const tabTypes = {
    basicInfo: {
        id: "basicInfo",
        title: "اطلاعات پایه",
    },
    productImages: {
        id: "productImages",
        title: "تصاویر محصول",
    },
    productVariant:{
        id:"productVariant",
        title:"نوع محصول"
    },
    enabled:{
        id: "enabled",
        title: "انتشار",
    },
}